//请自行添加语言资源
const orderMiv = {
  orderNo:'订单编码',
  url:'链接地址',
  createTime:"创建时间",
  pushTime:"推送时间",
  confirmTime:"确认时间",
  pushStatus:"推送状态",
  pushResult:"推送结果",
  msg:{
  }
};
export default orderMiv



// WEBPACK FOOTER //
// ./src/page/orderMiv/lang/orderMiv.zh.js